import { render, staticRenderFns } from "./ScenarioMessageIndex.vue?vue&type=template&id=21536fb7&scoped=true&"
import script from "./ScenarioMessageIndex.vue?vue&type=script&lang=js&"
export * from "./ScenarioMessageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21536fb7",
  null
  
)

export default component.exports